<template>
    <div
        class="container justify-content-center align-items-center vh-100"
        :class="{'d-flex': loading, 'd-none': !loading}"
    >
        <div>
            <i class="fa-solid fa-spinner fa-spin fa-2xl"></i>
            <span> Carregando... </span>
        </div>
    </div>
    <div v-show="!loading">
        <div
            v-if="jitsi_domain">
            <div id="meet"></div>
            <div class="p-5" v-if="iframe_error">
                <div class="alert alert-danger">
                    <ul class="m-0 fw-bold">
                        <li>
                            Ocorreu um erro ao disponibilizar a aula, aguarde enquando tentamos novamente.
                        </li>
                        <li>
                            Detalhes: {{iframe_error}}
                        </li>
                        <li v-if="iframe_error === 'Problema de rede'">
                            Aqui estão algumas sugestões que podem resolver o problema:
                            <ul>
                                <li>Verifique se você possui uma conexão estável com a internet.</li>
                                <li>Se você estiver em um ambiente corporativo, a empresa pode bloquear o acesso à sala de aula virtual, o que pode estar impedindo o funcionamento correto do nosso sistema.</li>
                            </ul>
                        </li>
                        <li>
                            Não feche esta janela e faça as validações biométricas para
                            que sua presença seja validada.
                        </li>
                        <li>
                            Caso o problema continue, entre em contato com o suporte.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div
            v-else
            class="p-5">
            <div class="d-flex flex-column flex-center flex-column-fluid m-2">
                <div class="d-flex flex-column flex-center text-center p-10">
                    <div class="card card-flush w-md-650px py-5">
                        <div class="card-body">
                            <div class="mb-10 mt-5">
                                <i class="fa-solid fa-spinner fa-spin fa-2xl" style="font-size: 40px;"></i>
                            </div>

                            <h1
                                class="fw-bolder text-gray-900"
                                style="font-size: 30px">
                                Estamos preparando a sua aula !
                            </h1>

                            <div class="fw-bolder fs-3 text-gray-500 mb-5">
                                Esta operação pode levar alguns minutos, em seguida você entrará automaticamente na sala.
                            </div>

                            <div
                                id="starting_class"
                                class="notice d-flex bg-light-warning rounded border-warning border border-dashed m-10 p-5"
                               >
                                <div class="d-flex flex-stack flex-grow-1">
                                    <div class="fw-semibold">
                                        <h4 class="text-gray-900 fw-bold">
                                            Não feche esta janela e faça as validações biométricas para
                                            que sua presença seja validada.
                                        </h4>
                                        <div class="fs-6 text-gray-700">
                                            De acordo com a normativa do Detran, o
                                            sistema mantém sua webcam ligada e pode
                                            tirar fotos durante a aula.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, Ref, ref } from 'vue';
    import JitsiIframeAPI from '../../utils/JitsiIframeAPI';

	const props = defineProps({
		room_name: { type: String, required: true },
		token_jwt: { type: String, required: true },
		jitsi_domain: { type: String, required: false },
        toolbar_buttons: {type: Array<String>, required: true}
	});

    const emits = defineEmits<{
        (e: 'successfully_loaded', api: any): void,
        (e: 'attachments_button_clicked'),
    }>()

	const iframe_error: Ref<string | null> = ref(null);

    const loading = ref(false);

    const api = ref(null);

	onMounted(async () => {
        if(props.jitsi_domain) {
            try {
                const options = {
                    domain: props.jitsi_domain,
                    scriptSource: `https://${props.jitsi_domain}/external_api.js`,
                    roomName: props.room_name,
                    jwt: props.token_jwt,
                    width: '100%',
                    configOverwrite: {
                        toolbarButtons: props.toolbar_buttons,
                        startWithAudioMuted: false,
                    },
                    lang: 'ptBR',
                    parentNode: document.querySelector('#meet'),
                };

                loading.value = true;

                const jitsi_api = new JitsiIframeAPI(options);

                api.value = await jitsi_api.startJitsi();

                //@ts-ignore
                api.value.addListener('toolbarButtonClicked', function (button) {
                    if (button.key === 'class-attachments') {
                        emits('attachments_button_clicked');
                    }
                })

                emits('successfully_loaded', api.value)
            } catch (error) {
                iframe_error.value = error as string;
            } finally {
                loading.value = false;
            }
        }
	});
</script>

